export const KILLI_ENVS = {
  LOCAL: 'local',
  SANDBOX: 'sandbox',
  DEVELOPMENT: 'development',
  PRE_PROD: 'pre-prod',
  STAGING: 'staging',
  PRODUCTION: 'production',
}

export const IS_PRODUCTION = process.env.REACT_APP_KILLI_ENV === KILLI_ENVS.PRODUCTION
export const IS_NOT_PRODUCTION = !IS_PRODUCTION

export default {
  IS_PRODUCTION,
  IS_NOT_PRODUCTION,
}
